
// There may be multiple reasons a page is busy. Use this class to track a
// count of them and display the busy indicator as long as something is still busy.
export class PageBusyIndicator {
    private count = 0;
    private spanSpinner: HTMLSpanElement;

    constructor(spanSpinnerId: string) {
        this.spanSpinner = (document.getElementById(spanSpinnerId)) as HTMLSpanElement;
    }

    public Increment = async () => {
        this.count++;
        await this.ShowHideBusyIndicator();
    }

    public Decrement = async () => {
        if (this.count >= 0) {
            this.count--;
            await this.ShowHideBusyIndicator();
        }
    }

    public IsBusy = () => this.count > 0;

    private ShowHideBusyIndicator = async () => {
        if (this.spanSpinner !== null) {
            if (this.count > 0 && !this.spanSpinner.classList.contains("ReportSpinner"))
                this.spanSpinner.classList.add("ReportSpinner");
            else if (this.count <= 0 && this.spanSpinner.classList.contains("ReportSpinner"))
                this.spanSpinner.classList.remove("ReportSpinner");
        }
    }
}
